import React from 'react';
import { Helmet } from 'react-helmet-async';
import PublicLayout from '../components/PublicLayout';

const TermsOfService: React.FC = () => {
  return (
    <PublicLayout>
      <Helmet>
        <title>Terms of Service | Manatomy AI</title>
        <meta name="description" content="Terms of Service for using Manatomy AI services." />
      </Helmet>
      <div className="max-w-3xl mx-auto px-4 lg:px-6 py-12">
        <div className="prose prose-gray max-w-none space-y-6 text-secondary">
          <section>
            <h1 className="text-3xl font-semibold text-primary mb-6">AI Terms of Service</h1>
            <ul className="text-sm mb-2">
              <li><strong>Effective Date:</strong> 12/12/2025</li>
              <li><strong>Website:</strong> <a href="https://ai.themanatomy.com" className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">ai.themanatomy.com</a></li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-medium text-primary mb-3">1. Acceptance of Terms</h2>
            <p>
              By accessing or using the Manatomy AI platform, you agree to be bound by these Terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-medium text-primary mb-3">2. Description of Service</h2>
            <ul className="list-disc list-inside">
              <li>The Manatomy AI platform provides automated styling recommendations based on user-uploaded images and user inputs.</li>
              <li>The platform does <strong>not</strong> provide medical, dermatological, or professional advice.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-medium text-primary mb-3">3. User Responsibilities</h2>
            <ul className="list-disc list-inside">
              <li>You will upload only your own photograph or a photo you have legal rights to use.</li>
              <li>You will not upload unlawful, offensive, or third-party copyrighted content.</li>
              <li>You will not misuse or attempt to reverse-engineer the AI system.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-medium text-primary mb-3">4. AI Disclaimer</h2>
            <ul className="list-disc list-inside">
              <li>AI recommendations are generated algorithmically.</li>
              <li>Results are suggestions and are not guaranteed outcomes.</li>
              <li>Manatomy is not liable for dissatisfaction arising from styling recommendations.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-medium text-primary mb-3">5. Intellectual Property</h2>
            <ul className="list-disc list-inside">
              <li>All AI models, algorithms, software, and content belong exclusively to Manatomy.</li>
              <li>Users retain ownership of their uploaded images.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-medium text-primary mb-3">6. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, Manatomy shall not be liable for:
            </p>
            <ul className="list-disc list-inside">
              <li>Indirect or consequential damages</li>
              <li>Loss of profits</li>
              <li>Styling dissatisfaction</li>
              <li>Technical interruptions</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-medium text-primary mb-3">7. Termination</h2>
            <p>
              We reserve the right to suspend or terminate access if these Terms are violated.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-medium text-primary mb-3">8. Governing Law</h2>
            <p>
              These Terms shall be governed by the laws of India.<br />
              <strong>Jurisdiction:</strong> Gurgaon, India.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-medium text-primary mb-3">9. Changes to Terms</h2>
            <p>
              We may update these Terms at any time. Continued use implies acceptance of the updated Terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-medium text-primary mb-3">Contact</h2>
            <p>
              For any questions, contact: <a href="mailto:help@themanatomy.com" className="text-primary hover:underline">help@themanatomy.com</a>
            </p>
            <p>
              <strong>The Manatomy</strong>
            </p>
          </section>
        </div>
      </div>
    </PublicLayout>
  );
};

export default TermsOfService;
